import { render } from "./QuestionListBlock.vue?vue&type=template&id=2f61c1ef"
import script from "./QuestionListBlock.vue?vue&type=script&lang=js"
export * from "./QuestionListBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__